import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/user-assignment/UserAssignmentAction";
import { CustomSelect, FormButton, getAuthorities, redirectToPages, UserType, UserTypeOptions } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { PersonnelUsersPage } from "./personnel-users/PersonnelUsersPage";
import { TeacherUsersPage } from "./teacher-users/TeacherUsersPage";
import { StudentUsersPage } from "./student-users/StudentUsersPage";
import { ParentUsersPage } from "./parent-users/ParentUsersPage";

export function UserAndUserGroupsPage({
  history,
  match: {
    params: { initialUserType }
  }
}) {
  const [userType, setUserType] = useState(parseInt(initialUserType));

  // Getting curret state of UserAssignment from store (Redux)
  const dispatch = useDispatch();
  const { actionLoading, isSuccess, type, authorities } = useSelector(
    (state) => ({
      actionLoading: state.userAssignment.actionLoading,
      isSuccess: state.userAssignment.isSuccess,
      type: state.userAssignment.type,
      authorities: state.userAssignment.authorities
    }),
    shallowEqual
  );

  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);
  
  useEffect(() => {
    dispatch(actions.getList());
    return () => dispatch(actions.cleanList());
  }, [dispatch]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const userTypeOptions = UserTypeOptions.filter(option => option.value !== UserType.System);
  
  return (
    <>
      <Card>
        {actionLoading && <ModalProgressBar />}
        <CardHeader title="Kullanıcı ve Kullanıcı Grubu Listesi">
          {
            isEditionAuthorized &&
            <CardHeaderToolbar>                    
              <FormButton 
                path="Navigation/Check"
                title="Kullanıcı Atama"
                method={() => history.push("/kullanici-ve-kullanici-gruplari/kullanici-atama")}
              />         
            </CardHeaderToolbar>
          }
        </CardHeader>
        <CardBody>
          <div className="form-group row">
            <div className="col-3 mt-3">
              Kullanıcı Türü
            </div>
            <div className="col-4">
              <CustomSelect
                options={userTypeOptions}
                value={userType}
                onChange={option => setUserType(option.value)}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      {
        userType === UserType.Personnel &&
        <PersonnelUsersPage />
      }
      {
        userType === UserType.Teacher &&
        <TeacherUsersPage />
      }
      {
        userType === UserType.Student &&
        <StudentUsersPage />
      }
      {
        userType === UserType.Parent &&
        <ParentUsersPage />
      }
    </>    
  );
}